"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffersSubPageContent = exports.OfferTitle = exports.OfferPropItem = exports.OfferMain = exports.OfferPropsWrapper = exports.ButtonWrapper = exports.DetailButton = exports.MoneyBagIcon = exports.OfferTypeIconWrapper = exports.MapIcon = exports.StyledSeparator = exports.OfferPropsText = exports.OffersContainer = exports.OfferLinkWrapper = exports.OffersTitle = exports.OfferLink = void 0;
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
const styled_components_1 = __importDefault(require("styled-components"));
exports.OfferLink = (0, styled_components_1.default)(elements_1.Link) `
	width: 100%;
	height: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	${(0, styled_breakpoints_1.up)('sm')} {
		flex-direction: row;
	}
`;
exports.OffersTitle = styled_components_1.default.div `
	text-align: center;
	width: 100%;
	padding: 1rem 1rem 0 1rem;
	font-size: 2rem;
	color: ${({ theme }) => theme.color.brand1};
`;
exports.OfferLinkWrapper = styled_components_1.default.div `
	padding: 1rem;
	position: relative;
	border: 1px solid ${({ theme }) => theme.color.gray4};
	transition: all 0.2s ease;
	cursor: pointer;

	&:hover {
		background: ${({ theme }) => theme.color.gray3};
	}
`;
exports.OffersContainer = styled_components_1.default.div `
	padding: 1rem 1rem;
	display: grid;
	grid-template-columns: repeat(1, minmax(240px, 1fr));
	gap: 1.5rem;
`;
exports.OfferPropsText = styled_components_1.default.div `
	font-size: 0.75rem;
	color: ${({ theme }) => theme.color.gray8};
`;
exports.StyledSeparator = (0, styled_components_1.default)(elements_1.Separator) `
	margin: 1rem 0;
`;
exports.MapIcon = (0, styled_components_1.default)(elements_1.Icon) `
	width: 1rem;
	min-width: 1rem;
	margin-right: 0.5rem;
`;
exports.OfferTypeIconWrapper = styled_components_1.default.span `
	margin-right: 0.5rem;
	display: flex;
	svg {
		color: ${({ theme }) => theme.color.brand1};
		width: 1rem;
		min-width: 1rem;
		g {
			stroke: ${({ theme }) => theme.color.brand1};
		}
		path {
			stroke: ${({ theme }) => theme.color.brand1};
		}
	}
`;
exports.MoneyBagIcon = (0, styled_components_1.default)(elements_1.Icon) `
	width: 1rem;
	min-width: 1rem;
	margin-right: 0.5rem;
`;
exports.DetailButton = (0, styled_components_1.default)(elements_1.Button) ``;
exports.ButtonWrapper = styled_components_1.default.div `
	padding-bottom: 0.5rem;
	height: 100%;
	display: flex;
	align-items: end;
	justify-content: center;
	${(0, styled_breakpoints_1.up)('md')} {
		padding-bottom: 0;
	}
`;
exports.OfferPropsWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
	}
`;
exports.OfferMain = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
`;
exports.OfferPropItem = styled_components_1.default.div `
	display: flex;
	align-content: center;
	margin-bottom: 0.5rem;

	${(0, styled_breakpoints_1.up)('md')} {
		margin: 0;
		margin-right: 1rem;
	}
`;
exports.OfferTitle = styled_components_1.default.div `
	font-weight: bold;
	font-size: 1rem;
	margin-bottom: 0.5rem;
`;
exports.OffersSubPageContent = styled_components_1.default.div `
	max-width: ${({ theme }) => theme.breakpoints.xl};
	margin: auto;
`;
